import React from 'react';

const LogoHead = ({ className, style }) => (
    <img
        src="/helix-logo.png"
        alt="Helix"
        className={`object-contain ${className}`}
        style={style}
    />
);

export default LogoHead;
